import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['./info-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InfoCardComponent {
  @Input() title!: string;
  @Input() titleTmpl: TemplateRef<any>;
  @Input() subtitle: string | number;
  @Input() subtitleTmpl: TemplateRef<any>;
  @Input() symbol?: string;
  @Input() icon: string;
  @Input() iconSize: 'small' | 'medium' = 'medium';
  @Input() isIconOutlined: boolean = false;
  @Input() color: 'white' | 'red' | 'green' | 'golden' | 'blue' | 'sky-blue' | 'navy' | 'orange' | 'muted-purple' | 'soft-lilac' = 'white';
  @Input() customClass: string = '';
}
